/* VELIO.LIFE — scroll-driven single-product experience */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (value, min, max) { return Math.min(Math.max(value, min), max); };
  var map = function (value, inMin, inMax, outMin, outMax) {
    var p = clamp((value - inMin) / (inMax - inMin), 0, 1);
    return outMin + (outMax - outMin) * p;
  };
  var smooth = function (t) { return t * t * (3 - 2 * t); };

  /* Hero words */
  document.querySelectorAll('[data-au-words]').forEach(function (el) {
    if (reduced || el.dataset.auWordsReady === 'true') return;
    var nodes = Array.prototype.slice.call(el.childNodes);
    el.textContent = '';
    var index = 0;
    nodes.forEach(function (node) {
      if (node.nodeType === 3) {
        node.textContent.split(/\s+/).filter(Boolean).forEach(function (word) {
          var outer = document.createElement('span');
          var inner = document.createElement('span');
          outer.className = 'au-word';
          inner.style.setProperty('--i', index++);
          inner.textContent = word;
          outer.appendChild(inner);
          el.appendChild(outer);
          el.appendChild(document.createTextNode(' '));
        });
      } else {
        var outer = document.createElement('span');
        var inner = document.createElement('span');
        outer.className = 'au-word';
        inner.style.setProperty('--i', index++);
        inner.appendChild(node.cloneNode(true));
        outer.appendChild(inner);
        el.appendChild(outer);
        el.appendChild(document.createTextNode(' '));
      }
    });
    el.dataset.auWordsReady = 'true';
  });

  /* Reveal */
  if ('IntersectionObserver' in window && !reduced) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -36px 0px' });
    document.querySelectorAll('.au-reveal, .au-reveal-scale').forEach(function (el) { revealObserver.observe(el); });
  } else {
    document.querySelectorAll('.au-reveal, .au-reveal-scale').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Signature scene */
  var experience = document.querySelector('[data-au-experience]');
  var spineHost = experience ? experience.querySelector('[data-au-spine]') : null;
  var spinePath = spineHost ? spineHost.querySelector('.au-spine__path') : null;
  var spineShadow = spineHost ? spineHost.querySelector('.au-spine__shadow') : null;
  var spineDots = spineHost ? spineHost.querySelectorAll('.au-spine__dot') : [];
  var productShell = spineHost ? spineHost.querySelector('.au-experience__product-shell') : null;
  var stateLabel = spineHost ? spineHost.querySelector('[data-au-state]') : null;
  var progressBars = experience ? experience.querySelectorAll('[data-au-progress]') : [];
  var beats = experience ? experience.querySelectorAll('[data-au-beat]') : [];
  var curved = 'M100 20 C 154 95, 153 176, 118 258 C 91 320, 88 384, 105 438';
  var straight = 'M100 20 C 104 98, 100 176, 100 258 C 100 320, 100 384, 100 438';
  var curvedNumbers = curved.match(/-?\d+(\.\d+)?/g).map(Number);
  var straightNumbers = straight.match(/-?\d+(\.\d+)?/g).map(Number);

  function interpolatePath(t) {
    var i = 0;
    return curved.replace(/-?\d+(\.\d+)?/g, function () {
      var value = curvedNumbers[i] + (straightNumbers[i] - curvedNumbers[i]) * t;
      i += 1;
      return value.toFixed(1);
    });
  }

  function setBeat(index) {
    beats.forEach(function (beat, beatIndex) {
      beat.classList.toggle('is-active', beatIndex === index);
      beat.setAttribute('aria-hidden', beatIndex === index ? 'false' : 'true');
    });
  }

  function updateExperience() {
    if (!experience || !spinePath || reduced) return;
    var rect = experience.getBoundingClientRect();
    var range = Math.max(experience.offsetHeight - window.innerHeight, 1);
    var t = clamp(-rect.top / range, 0, 1);
    var spineT = smooth(map(t, .05, .78, 0, 1));
    var d = interpolatePath(spineT);
    spinePath.setAttribute('d', d);
    if (spineShadow) spineShadow.setAttribute('d', d);

    var length = spinePath.getTotalLength();
    spineDots.forEach(function (dot, index) {
      var point = spinePath.getPointAtLength((length / Math.max(spineDots.length - 1, 1)) * index);
      dot.setAttribute('cx', point.x);
      dot.setAttribute('cy', point.y);
    });

    var productT = smooth(map(t, .36, .95, 0, 1));
    if (productShell) {
      productShell.style.setProperty('--au-product-opacity', map(productT, 0, 1, 0, .98).toFixed(3));
      productShell.style.setProperty('--au-product-y', map(productT, 0, 1, 72, 0).toFixed(1) + 'px');
      productShell.style.setProperty('--au-product-scale', map(productT, 0, 1, .72, 1.03).toFixed(3));
    }

    if (spineHost) spineHost.style.setProperty('--au-progress', (t * 100).toFixed(2) + '%');
    progressBars.forEach(function (bar) { bar.style.setProperty('--au-progress', (t * 100).toFixed(2) + '%'); });

    var beatIndex = t < .34 ? 0 : (t < .69 ? 1 : 2);
    setBeat(beatIndex);
    if (stateLabel) stateLabel.textContent = beatIndex === 0 ? 'Eingesackt' : (beatIndex === 1 ? 'Erinnert' : 'Aufgerichtet');
    experience.classList.toggle('is-resolved', beatIndex === 2);
  }

  if (spinePath) {
    var startLength = spinePath.getTotalLength();
    spineDots.forEach(function (dot, index) {
      var point = spinePath.getPointAtLength((startLength / Math.max(spineDots.length - 1, 1)) * index);
      dot.setAttribute('cx', point.x);
      dot.setAttribute('cy', point.y);
    });
  }
  setBeat(reduced ? 2 : 0);

  /* FAQ */
  document.querySelectorAll('.au-qa').forEach(function (qa) {
    var button = qa.querySelector('.au-qa__q');
    var panel = qa.querySelector('.au-qa__a');
    button.addEventListener('click', function () {
      var opening = !qa.classList.contains('is-open');
      document.querySelectorAll('.au-qa.is-open').forEach(function (openQa) {
        if (openQa === qa) return;
        openQa.classList.remove('is-open');
        openQa.querySelector('.au-qa__q').setAttribute('aria-expanded', 'false');
        openQa.querySelector('.au-qa__a').style.height = '0px';
      });
      qa.classList.toggle('is-open', opening);
      button.setAttribute('aria-expanded', opening ? 'true' : 'false');
      panel.style.height = opening ? panel.scrollHeight + 'px' : '0px';
      if (opening) {
        panel.addEventListener('transitionend', function () {
          if (qa.classList.contains('is-open')) panel.style.height = 'auto';
        }, { once: true });
      }
    });
  });

  /* Local preview cart: mirrors the Shopify drawer journey end to end. */
  var previewDrawer = document.querySelector('[data-preview-cart-drawer]');
  if (previewDrawer) {
    var previewCartQuantity = Number(window.localStorage.getItem('velioPreviewCart') || 0);
    var previewCartTrigger = document.querySelector('[data-preview-cart-open]');
    var previewCartCount = document.querySelector('[data-preview-cart-count]');
    var previewCartHeadingCount = document.querySelector('[data-preview-cart-heading-count]');
    var previewCartEmpty = document.querySelector('[data-preview-cart-empty]');
    var previewCartFilled = document.querySelector('[data-preview-cart-filled]');
    var previewCartFooter = document.querySelector('[data-preview-cart-footer]');
    var previewCartQuantityText = document.querySelector('[data-preview-cart-quantity]');
    var previewCartLinePrice = document.querySelector('[data-preview-cart-line-price]');
    var previewCartTotal = document.querySelector('[data-preview-cart-total]');
    var previewLastFocus = null;

    function formatPreviewPrice(quantity) {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(39.90 * quantity);
    }

    function renderPreviewCart() {
      var hasItems = previewCartQuantity > 0;
      window.localStorage.setItem('velioPreviewCart', String(previewCartQuantity));
      previewCartCount.hidden = !hasItems;
      previewCartCount.textContent = String(previewCartQuantity);
      previewCartHeadingCount.textContent = hasItems ? '(' + previewCartQuantity + ')' : '';
      previewCartEmpty.hidden = hasItems;
      previewCartFilled.hidden = !hasItems;
      previewCartFooter.hidden = !hasItems;
      if (hasItems) {
        previewCartQuantityText.textContent = String(previewCartQuantity);
        previewCartLinePrice.textContent = formatPreviewPrice(previewCartQuantity);
        previewCartTotal.textContent = formatPreviewPrice(previewCartQuantity);
      }
    }

    function openPreviewCart() {
      previewLastFocus = document.activeElement;
      previewDrawer.classList.add('is-open');
      previewDrawer.setAttribute('aria-hidden', 'false');
      previewCartTrigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('preview-cart-open');
      window.setTimeout(function () { previewDrawer.querySelector('[data-preview-cart-close]').focus(); }, 30);
    }

    function closePreviewCart() {
      previewDrawer.classList.remove('is-open');
      previewDrawer.setAttribute('aria-hidden', 'true');
      previewCartTrigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('preview-cart-open');
      if (previewLastFocus && previewLastFocus.focus) previewLastFocus.focus();
    }

    previewCartTrigger.addEventListener('click', openPreviewCart);
    previewDrawer.querySelectorAll('[data-preview-cart-close]').forEach(function (button) { button.addEventListener('click', closePreviewCart); });
    previewDrawer.querySelector('[data-preview-cart-plus]').addEventListener('click', function () { previewCartQuantity += 1; renderPreviewCart(); });
    previewDrawer.querySelector('[data-preview-cart-minus]').addEventListener('click', function () { previewCartQuantity = Math.max(0, previewCartQuantity - 1); renderPreviewCart(); });
    previewDrawer.querySelector('[data-preview-cart-remove]').addEventListener('click', function () { previewCartQuantity = 0; renderPreviewCart(); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && previewDrawer.classList.contains('is-open')) closePreviewCart(); });

    document.querySelectorAll('[data-preview-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        var label = button.querySelector('[data-preview-add-label]');
        var feedback = document.querySelector('[data-preview-cart-feedback]');
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (label) label.textContent = 'Wird hinzugefügt …';
        window.setTimeout(function () {
          previewCartQuantity += 1;
          renderPreviewCart();
          if (label) label.textContent = 'In den Warenkorb';
          if (feedback) feedback.textContent = 'VELIO Haltungstrainer Pro wurde hinzugefügt.';
          button.removeAttribute('aria-busy');
          button.disabled = false;
          openPreviewCart();
        }, 320);
      });
    });

    renderPreviewCart();
  }

  /* Sticky buy and kinetic finale — one frame per scroll */
  var stickyBar = document.querySelector('[data-au-stickybar]');
  var buySection = document.querySelector('[data-au-buy]');
  var kinetic = document.querySelectorAll('[data-au-kinetic]');
  var frameRequested = false;

  function updateScrollFrame() {
    updateExperience();

    if (stickyBar && buySection) {
      var buyRect = buySection.getBoundingClientRect();
      var storyGate = experience ? experience.offsetTop + experience.offsetHeight - window.innerHeight * .75 : window.innerHeight * .82;
      var show = window.scrollY > storyGate && (buyRect.top > window.innerHeight * .84 || buyRect.bottom < 0);
      stickyBar.classList.toggle('is-visible', show);
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    if (!reduced) {
      kinetic.forEach(function (el) {
        var direction = parseFloat(el.getAttribute('data-au-kinetic')) || 1;
        el.style.transform = 'translate3d(' + (-((window.scrollY * .09 * direction) % 520)).toFixed(1) + 'px,0,0)';
      });
    }
    frameRequested = false;
  }

  function requestScrollFrame() {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(updateScrollFrame);
  }
  window.addEventListener('scroll', requestScrollFrame, { passive: true });
  window.addEventListener('resize', requestScrollFrame);
  updateScrollFrame();

  /* Tactile desktop buttons */
  if (!reduced && window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.au-btn').forEach(function (button) {
      button.addEventListener('mousemove', function (event) {
        var rect = button.getBoundingClientRect();
        var x = (event.clientX - rect.left - rect.width / 2) * .08;
        var y = (event.clientY - rect.top - rect.height / 2) * .12;
        button.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
      });
      button.addEventListener('mouseleave', function () { button.style.transform = ''; });
    });
  }
})();
